// Field Editor Utility Functions

export function determineDisplayType(pdfFieldType) {
  if (!pdfFieldType) return 'text';
  const type = pdfFieldType.toLowerCase();
  if (type.includes('date')) return 'date';
  if (type.includes('number')) return 'number';
  if (type.includes('signature') || type.includes('sig')) return 'signature';
  if (type.includes('text')) return 'text';
  if (type.includes('checkbox')) return 'checkbox';
  if (type.includes('radio')) return 'radio';
  if (type.includes('choice') || type.includes('list')) return 'dropdown';
  return 'text';
}

export function formatFieldName(fieldName) {
  if (!fieldName) return '';
  let formatted = fieldName.replace(/[_-]/g, ' ');
  formatted = formatted.replace(/([a-z])([A-Z])/g, '$1 $2');
  const words = formatted.split(' ');
  for (let i = 0; i < words.length; i++) {
    if (words[i].length > 0) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
    }
  }
  return words.join(' ');
}

export function generateId() {
  return 'field-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
}

export function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// Check if a PDF field is a text type
export function isTextFieldType(pdfField) {
  if (!pdfField) return false;
  const type = pdfField.type || '';
  const isTextField = type === 'PDFTextField' ||
    type === 'text' ||
    type === '/Tx' ||
    type === 'Tx' ||
    (type && type.toLowerCase().includes('text'));
  const isNotOtherType = !type ||
    (!type.toLowerCase().includes('checkbox') &&
      !type.toLowerCase().includes('radio') &&
      !type.toLowerCase().includes('button') &&
      !type.toLowerCase().includes('signature') &&
      type !== '/Btn' &&
      type !== 'Btn');
  return isTextField || isNotOtherType;
}

export function overlayPixelsToPdfBounds(viewport, left, top, width, height) {
  const [pdfX1, pdfY1] = viewport.convertToPdfPoint(left, top + height);
  const [pdfX2, pdfY2] = viewport.convertToPdfPoint(left + width, top);
  return {
    x: Math.min(pdfX1, pdfX2),
    y: Math.min(pdfY1, pdfY2),
    width: Math.abs(pdfX2 - pdfX1),
    height: Math.abs(pdfY2 - pdfY1)
  };
}

export function clientRectToPdfBounds(viewport, overlayRect, elRect) {
  return overlayPixelsToPdfBounds(
    viewport,
    elRect.left - overlayRect.left,
    elRect.top - overlayRect.top,
    elRect.width,
    elRect.height
  );
}

// Convert viewport coordinates to PDF coordinates
export async function viewportToPdfCoords(pdfDocRef, pageNum, scale, left, top, width, height) {
  const page = await pdfDocRef.getPage(pageNum);
  const vp = page.getViewport({ scale });
  return overlayPixelsToPdfBounds(vp, left, top, width, height);
}

// Convert PDF coordinates to viewport coordinates
export function pdfToViewportCoords(viewport, bounds) {
  if (!bounds) return null;
  
  // PDF coordinates: Y=0 at bottom, increasing upward
  // Viewport coordinates: Y=0 at top, increasing downward
  
  // Get the top-left corner in viewport coordinates (PDF top = y + height)
  const [x1, y1] = viewport.convertToViewportPoint(bounds.x, bounds.y + bounds.height);
  // Get the bottom-right corner in viewport coordinates (PDF bottom = y)
  const [x2, y2] = viewport.convertToViewportPoint(bounds.x + bounds.width, bounds.y);
  
  return {
    x: Math.min(x1, x2),
    y: Math.min(y1, y2),
    width: Math.abs(x2 - x1),
    height: Math.abs(y2 - y1)
  };
}

// Get default field size based on type
export function getDefaultFieldSize(fieldType) {
  if (fieldType === 'radio' || fieldType === 'checkbox') {
    return { width: 20, height: 20 };
  } else if (fieldType === 'signature') {
    return { width: 200, height: 60 };
  } else {
    return { width: 150, height: 30 };
  }
}
